import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

import UploadDocument from "./UploadDocument";
import ChatMessage from "./ChatMessage";

const ChatBot = () => {

    const [messages, setMessages] = useState([]);

    const [question, setQuestion] = useState("");

    const [loading, setLoading] = useState(false);

    const messagesEndRef = useRef(null);

    // Unique conversation id
    const [threadId] = useState(() => {

        const existing = localStorage.getItem("thread_id");

        if (existing) return existing;

        const id = crypto.randomUUID();

        localStorage.setItem("thread_id", id);

        return id;

    });

    useEffect(() => {

        scrollToBottom();

    }, [messages]);

    const scrollToBottom = () => {

        messagesEndRef.current?.scrollIntoView({

            behavior: "smooth"

        });

    };

    const currentTime = () => {

        return new Date().toLocaleTimeString([], {

            hour: "2-digit",

            minute: "2-digit"

        });

    };

    const sendMessage = async () => {

        if (!question.trim()) return;

        const userMessage = {

            sender: "user",

            text: question,

            time: currentTime()

        };

        setMessages(prev => [...prev, userMessage]);

        const userQuestion = question;

        setQuestion("");

        setLoading(true);

        try {

            const response = await axios.post(

                "http://127.0.0.1:8000/api/chatbot/chat/",

                {

                    question: userQuestion,

                    thread_id: threadId

                }

            );

            const aiMessage = {

                sender: "ai",

                text: response.data.answer,

                sources: response.data.sources,

                time: currentTime()

            };

            setMessages(prev => [

                ...prev,

                aiMessage

            ]);

        } catch (error) {

            setMessages(prev => [

                ...prev,

                {

                    sender: "ai",

                    text: "Unable to connect to AI server.",

                    time: currentTime()

                }

            ]);

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    const handleKeyDown = (e) => {

        if (e.key === "Enter") {

            sendMessage();

        }

    };

    return (

        <div

            style={{

                width: "900px",

                margin: "30px auto",

                border: "1px solid #ddd",

                borderRadius: "10px",

                overflow: "hidden",

                background: "#fff",

                boxShadow: "0px 2px 10px rgba(0,0,0,0.2)"

            }}

        >

            <div

                style={{

                    background: "#2563eb",

                    color: "white",

                    padding: "20px",

                    fontSize: "22px",

                    fontWeight: "bold"

                }}

            >

                AI Knowledge Assistant

            </div>

            <div

                style={{

                    padding: "20px"

                }}

            >

                <UploadDocument />

            </div>

            <div

                style={{

                    height: "450px",

                    overflowY: "auto",

                    padding: "20px",

                    background: "#f7f7f7"

                }}

            >

                {

                    messages.length === 0 && (

                        <div

                            style={{

                                textAlign: "center",

                                color: "gray",

                                marginTop: "150px"

                            }}

                        >

                            Upload a document and ask your question.

                        </div>

                    )

                }

                {

                    messages.map((message, index) => (

                        <ChatMessage

                            key={index}

                            message={message}

                        />

                    ))

                }

                {

                    loading && (

                        <div

                            style={{

                                marginBottom: "20px"

                            }}

                        >

                            🤖 AI is thinking...

                        </div>

                    )

                }

                <div ref={messagesEndRef}></div>

            </div>

            <div

                style={{

                    display: "flex",

                    padding: "20px",

                    gap: "10px",

                    borderTop: "1px solid #ddd"

                }}

            >

                <input

                    type="text"

                    placeholder="Ask your question..."

                    value={question}

                    onChange={(e) =>

                        setQuestion(e.target.value)

                    }

                    onKeyDown={handleKeyDown}

                    style={{

                        flex: 1,

                        padding: "12px",

                        fontSize: "16px",

                        borderRadius: "5px",

                        border: "1px solid #ccc"

                    }}

                />

                <button

                    onClick={sendMessage}

                    disabled={loading}

                    style={{

                        background: "#2563eb",

                        color: "white",

                        border: "none",

                        padding: "12px 25px",

                        cursor: "pointer",

                        borderRadius: "5px"

                    }}

                >

                    Send

                </button>

            </div>

        </div>

    );

};

export default ChatBot;